import { Product, Variant } from "@/types/types.ts";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./GalleryTeaser.module.scss";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import { useState } from "react";
import ZoomCross24PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ZoomCross24PxOutlined";
import { ZoomModal } from "@/components/Galleries/components/ZoomModal/ZoomModal.tsx";
import { getGalleryObjects } from "../utils";

export interface GalleryTeaserUIProps {
  product: Product;
  variant: Variant;
  openModalOnClick: boolean;
}

export const ImageHeight = 320;
export const ImageWidth = 240;

export const GalleryTeaserUI = ({
  variant,
  product,
  openModalOnClick,
}: GalleryTeaserUIProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const hasMultipleImages = !!variant.images.alternatives.length;

  const media = "media" in product ? product.media : null;
  const videoItems = media?.videos || [];

  const { images, videos } = getGalleryObjects(
    variant.title,
    variant.images,
    videoItems,
  );

  const handleScrollToGallery = () => {
    const carouselGalleryScrollEvent = new CustomEvent(
      "carousel-gallery-scroll-into-view",
    );
    document.dispatchEvent(carouselGalleryScrollEvent);
  };
  const handleViewImagesButtonClick = openModalOnClick
    ? () => setIsOpen(true)
    : handleScrollToGallery;

  return (
    <div
      data-testid="gallery-teaser"
      className={styles.wrapper}
      data-component="GalleryTeaser"
    >
      {isOpen && (
        <ZoomModal
          closeZoomModal={() => setIsOpen(false)}
          mediaItems={[...images, ...videos]}
          setSelectedIndex={setSelectedIndex}
          selectedIndex={selectedIndex}
        />
      )}
      <button
        type="button"
        className={styles.mainImageButton}
        onClick={handleViewImagesButtonClick}
        aria-label="main product image"
        data-testid="gallery-teaser:main-image:button"
      >
        {openModalOnClick && (
          <div className={styles.zoomButton}>
            <ZoomCross24PxOutlinedIcon className={styles.zoomIcon} />
            Zoom
          </div>
        )}
        <img
          src={formatAmplienceImageURL(
            `${variant.images.primary}?wid=${ImageWidth}&hei=${ImageHeight}`,
          )}
          alt={variant.title}
          className={styles.mainImage}
        />
      </button>
      {!openModalOnClick && (
        <UnderlinedButton
          onClick={handleViewImagesButtonClick}
          className={styles.viewMore}
        >
          {hasMultipleImages ? "View images" : "View image"}
        </UnderlinedButton>
      )}
    </div>
  );
};
